import axiosClient from "./axiosClient.js";

const zaloApi = {
  loginQR: () => {
    const url = `/zalo/loginQR`;
    return axiosClient.get(url);
  },
  undo: (data) => {
    const url = `/zalo/undo`;
    return axiosClient.post(url, data);
  },
  sendMessage: (data) => {
    const url = `/zalo/sendMessage`;
    return axiosClient.post(url, data);
  },
  sendFile: (data) => {
    const formData = new FormData();
    formData.append("file", data.file, data.file.name);

    const url = `/zalo/sendFile`;
    return axiosClient.post(url, formData, {
      params: {
        shopId: data.shopId,
        id: data.id,
        isGroup: data.isGroup,
        cliMsgId: data.cliMsgId,
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  getStickers: (data) => {
    const url = `/zalo/getStickers`;
    return axiosClient.post(url, data);
  },
  sendSticker: (data) => {
    const url = `/zalo/sendSticker`;
    return axiosClient.post(url, data);
  },
  sendCard: (data) => {
    const url = `/zalo/sendCard`;
    return axiosClient.post(url, data);
  },
};

export default zaloApi;
